import CaretLeftIcon from './CaretLeftIcon';
export default CaretLeftIcon;
